<template>
	<div class="post-page-container">
		<v-skeleton-loader v-if="this.isLoading" v-bind="attrs" type="card"></v-skeleton-loader>
		<Post v-else-if='!this.isLoading && !this.notFound' :post="this.post" />

		<v-card v-if="!this.isLoading && this.notFound" style='box-shadow: none;'>
			<div class="mt-7 mb-4 pa-4">
				<div
					class="page-title cursor-pointer text-decoration-none d-flex align-center"
					@click='$router.go(-1)'
				>
					<img :src="arrowIcon"  class="mr-3" alt=''>
					<span class="text-decoration-underline font-weight-bold">Back</span>
				</div>
			</div>
		</v-card>

		<NewsFeedEmpty
			v-if="!this.isLoading && this.notFound"
			class='mt-7'
			title="Thread not found at this moment."
			description="Check back later."
		/>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import Post from '@/components/Post/Post'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'
import arrowIcon from '@/assets/images/resourcesIcon/arrow-icon.svg'
import _ from 'lodash'

export default {
	name: 'PostPage',
	components: {
		NewsFeedEmpty,
		Post,
	},
	data() {
		return {
			arrowIcon,
			attrs: {
				elevation: 0,
				class: 'pt-7',
			},
		}
	},
	computed: {
		...mapGetters('post', ['post', 'isLoading', 'postNotFound']),

		notFound() {
			return this.postNotFound;
		}
	},
	methods: {
		...mapActions('post', ['getPost']),
	},
	created() {
		if (this.$route.params.id !== undefined) {
			this.getPost(this.$route.params.id)
		}
	},
}
</script>

<style lang="scss">
.post-page {
	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}
}

@media screen and (min-width: 1200px) {
	.post-page-container {
		max-width: 100%;
		width: 100%;
	}
}

@media screen and (min-width: 1320px) {
	.post-page-container {
		max-width: 600px;
	}
}
</style>
